<template>
    <div>
        <section id="bump" class="bump app">
            <div class="bump-wrapper">
                <div class="bump-inner">
                    <div class="bump-inner-app">
                        <div class="logo">
                            <a href="/" @click.prevent>
                              <img v-if="domain === 'bump'" src="/main/img/icons/BUMP-logo-landing.svg" alt="Bump" />
                              <h1 v-if="domain === 'share'" class="hero-title">BUDDY</h1>
                            </a>
                          <div class="logo-title"><span>{{trans('home.'+domain+'_landing_title')}}</span></div>
                        </div>
                      <div class="appstore-logo">
                        <a target="_blank" href="https://apps.apple.com/app/bump-gay-private-parties/id6744515071">
                          <img src="/main/img/icons/Download_on_the_App_Store_Badge.svg" />
                        </a>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.bumpdudes&pcampaignid=app_share">
                          <img src="/main/img/icons/Google_Play_Store_badge_EN.svg.png" />
                        </a>
                      </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import $ from "jquery";
    import scrollify from "jquery-scrollify";
    import easing from "jquery.easing";

    import Lang from "@buddy/views/new/widgets/Lang";
    import Login from "@buddy/views/new/widgets/Login";
    // import Announce from "@buddy/views/new/widgets/Announce";

    export default {
        components: {
            Lang,
            Login,
            // Announce,
        },
        computed: {
          domain() {
            return window.location.hostname === window.SHARE_DOMAIN ? 'share' : 'bump'
          },
        },
        data: () => ({
            timer: 0,
            window: $(window),
            showLoginForm: false,
            uk_location:false,
            location_loaded:true,
        }),
        mixins: [
            require('@general/lib/mixin').default
        ],
        methods: {
          come_in(){
            location.href = '/discover';
          },
          showPagePopup(page) {
            //app.showLightLoading(true);

            let title = page == 'terms' ? this.trans('reg.terms_of_use') : this.trans('reg.privacy_policy');

            axios.get('/api/getStaticPage/'+app.lang+'/'+page)
                .then(({data}) => {
                  this.showErrorNotification(data.content);
                  //app.showLightLoading(false);
                })
                .catch(e => {
                  //app.showLightLoading(false);
                })
          },
            register() {
              const isMobile = app.isMobile;

              if (isMobile) {
                  location.href = '/barebuddy/register';
              } else {
                  this.openRegisterModal();
              }
            },
            toggleLoginForm(){
              this.showLoginForm = true;
              if(window.innerWidth < 1024){
                this.textShown = false;
              }
            },
            getLangText(lang) {
                if (this.isMobile) {
                    return this.trans(`${lang}_short`)
                } else {
                    return this.trans(`${lang}`)
                }
            },
            fireScrollControl(){
                let self = this
                let window_top = this.window.scrollTop()
                let window_height = this.window.height()
                let view_port_s = window_top
                let view_port_e = window_top + window_height

                $('.parallax').each(function(){
                    let obj = $(this)
                    obj.css({
                        'background-position' : 'center ' +
                            ( view_port_e - ( obj.offset().top + obj.height() - obj.height() / 2  ) ) / (-6)
                            + 'px'
                    })
                })

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                $('.fly').each(function(){
                    let block = $(this)
                    let block_top = block.offset().top
                    let block_height = block.height()

                    if (block_top < view_port_e) {
                        self.timer = setTimeout(function(){
                            block.addClass('show-block')
                        }, 50)
                    }
                })
            },
            init(){
                /*$.scrollify({
                    section : "#hero, #find, #browse, #download, #share, #sign-up, #footer",
                    interstitialSection: ".cookies-bar, #footer",
                    easing: "easeOutQuad",
                    scrollSpeed: 600,
                    offset: 0,
                    standardScrollElements: "#footer, .announce-body",
                    scrollbars: true,
                    overflowScroll: true,
                    setHeights: true,
                    updateHash: false,
                    touchScroll: true,
                })*/

                $('.languages').click(function() {
                    $('#languages').toggleClass('open');
                })

                $('.down').click(function() {
                    $.scrollify.next()
                })

                //$(window).scroll(this.fireScrollControl)
                //$(window).resize(this.fireScrollControl)

                //this.fireScrollControl()
            }
        },
        mounted() {
          console.log('[Home] Mounted')
            //uk location conditions
            let location = JSON.parse(localStorage.getItem('location'));
            if(location){
              if(['UK','GB'].includes(location.country_code)){
                this.uk_location = true;
              }
            }else{
              this.location_loaded = false;
              axios.post('/api/register/find-location')
                  .then(response => {
                    if(['UK','GB'].includes(response.data.country_code)){
                      this.uk_location = true;
                    }
                    this.location_loaded = true;
                  }).catch((e) => {
                this.location_loaded = true;
              })
            }

            const backUrl = this.$route.meta.back;

            if (backUrl === '/register') {
                this.openRegisterModal();
            } else if (backUrl === '/barebuddy/register') {
              this.openRegisterModal();
            } else if (backUrl === '/recover-password') {
                this.openRecoverPasswordModal();
            }

            this.init()
        }
    }
</script>
